import { paramsToQuery } from '@/base/MaUtils.js'
import { makePreRequest, makeRequest } from '@/base/MaRequestPooler.js'

export function getRefreshToken(impersonationId) {
  return makePreRequest(`/account/impersonate?impersonationId=${impersonationId}`)
}

export function updateContactInfo(params, newUser = false) {
  return makeRequest(`/account/user/contact-info?${paramsToQuery({ newUser })}`, {
    method: 'PUT',
    data: params || {},
  })
}

export function changePassword(data) {
  return makeRequest(`/authentication/change-password`, {
    method: 'POST',
    data: data || {},
  })
}

export function getTeamMembers() {
  return makeRequest(`/account/team-member`)
}

export function inviteTeamMembers(emails) {
  return makeRequest(`/account/team-member`, {
    method: 'POST',
    data: emails,
  })
}

export function makeTeamMemberAsAdmin({ userId }) {
  return makeRequest(`/account/team-member/${userId}/make-admin`, {
    method: 'POST',
  })
}

export function reinviteTeamMember({ userId }) {
  return makeRequest(`/account/team-member/${userId}/reinvite`, {
    method: 'POST',
  })
}

export function deleteTeamMember({ userId }) {
  return makeRequest(`/account/team-member/${userId}`, {
    method: 'DELETE',
  })
}

/**
 * we will migrate to this one instead of user info
 */
export function getUserProducts() {
  return makeRequest(`/account/products`)
}

export function getAppLists() {
  return makeRequest(`/account/user/app-list`)
}

export function addAppList(name, apps, shared = false) {
  return makeRequest(`/account/user/app-list?${paramsToQuery({ name, shared: shared === true })}`, {
    method: 'POST',
    data: apps,
  })
}

export function removeAppList(listId) {
  return makeRequest(`/account/user/app-list/${listId}`, { method: 'DELETE' })
}

/**
 * Add SSO Client
 * @param clientId //
 * @param metadataUrl //
 * @returns {Promise} //
 */
export function addSSOClient({ clientId, metadataUrl }) {
  return makeRequest('/account/sso', {
    method: 'POST',
    data: {
      clientId,
      metadataUrl,
    },
  })
}

/**
 * Update SSO Client
 * @param clientId //
 * @param metadataUrl //
 * @returns {Promise} //
 */
export function updateSSOClient({ clientId, metadataUrl }) {
  return makeRequest('/account/sso', {
    method: 'PUT',
    data: {
      clientId,
      metadataUrl,
      enable: true,
    },
  })
}

/**
 * Get SSO Clients
 * @returns {Promise} //
 */
export function getSSOClients() {
  return makeRequest('/account/sso')
}

/**
 * Check SSO
 * @returns {Promise} //
 */
export function checkSSO() {
  return makeRequest('/account/sso/enable')
}

/**
 * Delete SSO Client
 * @param idpType //
 * @returns {Promise} //
 */
export function deleteSSOClient(idpType) {
  return makeRequest(`/account/sso?${paramsToQuery({ idpType })}`, {
    method: 'DELETE',
  })
}
